import React from 'react';
import { WorkspacesApi } from '@emilgroup/auth-sdk';
import { publicApiUrl } from 'App/utils';

export const useWorkspacesApi = () => {
  const ref = React.useRef<WorkspacesApi>( new WorkspacesApi( undefined, publicApiUrl ) );
  return ref.current;
};
